import { Action, ThunkAction, configureStore, combineReducers } from '@reduxjs/toolkit';
import uiReducer from './app-ui.store';
import authReducer from './auth.store';
import driverReducer from './drivers.store';
import vehicleReducer from './vehicle.store';
import userReducer from './users.store';
import billingReducer from './billing.store';
import locationReducer from './location.store';
import fuelReducer from './fuel.store';
import serviceRecordReducer from './service.store';
import operationsReducer from './operations.store';
import tripsReducer from './trips.store';
import tripActionsReducer from './trip-actions.store';
import analyticsReducer from './analytics.store';
import driverTrackingReducer from './driverTracking.store';

const rootReducer = combineReducers({
  UI: uiReducer,
  auth: authReducer,
  // route: routeReducer,
  driver: driverReducer,
  vehicle: vehicleReducer,
  user: userReducer,
  billing: billingReducer,
  location: locationReducer,
  fuel: fuelReducer,
  serviceRecord: serviceRecordReducer,
  operations: operationsReducer,
  trips: tripsReducer,
  tripActions: tripActionsReducer,
  analytics: analyticsReducer,
  driverTracking: driverTrackingReducer,
});

export const store = configureStore({
  reducer: (state, action) => {
    if (action.type === 'USER_LOGOUT') {
      return rootReducer(undefined, action);
    }
    return rootReducer(state, action);
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
